export type SupportConcernType = 'TECHNICAL' | 'BILLING' | 'OTHER';

export const SUPPORT_CONCERN_OPTIONS: ReadonlyArray<{ value: SupportConcernType; label: string }> = [
  { value: 'TECHNICAL', label: 'Technical Issue' },
  { value: 'BILLING', label: 'Subscription / Billing' },
  { value: 'OTHER', label: 'Other Query' },
];

export function concernLabel(value: SupportConcernType): string {
  return SUPPORT_CONCERN_OPTIONS.find((o) => o.value === value)?.label ?? value;
}
